module.exports = __webpack_public_path__ + "static/img/logo15.091e1a7c.png";